import { createURL } from '@sm/utils';

export const getNavBarLOLinks = () => {
  return [
    {
      name: 'Products'
    },
    {
      name: 'Solutions'
    },
    {
      name: 'Resources'
    },
    {
      path: createURL('https://help.surveymonkey.com/', {
        ut_source: 'megamenu'
      }),
      name: 'Help Center'
    },
    {
      path: createURL('/pricing/', { ut_source: 'megamenu' }),
      name: 'Plans & Pricing'
    }
  ];
};

export default getNavBarLOLinks;
